import React, { useState, useEffect } from 'react';

const GoTop = () => {
    const [showGoTop, setShowGoTop] = useState(false);

    const handleGoTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const onScroll = () => {
            setShowGoTop(window.scrollY > 300); // show after scrolling 300px
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <div
            className={`go-top${showGoTop ? ' active' : ''}`}
            onClick={handleGoTop}
            style={{ cursor: 'pointer' }}
        >
            <i className='bx bx-chevrons-up'></i>
        </div>
    );
};

export default GoTop;
